import { sanitizeImageUrl } from "./imageUtils";
import { getBaseApiUrl } from "./tenant";

export const getConfiguredStorefrontBanners = (
  configuredSlides = [],
  activeSlides = [],
  primaryColor,
  excludedSlideIds = [],
) => {
  const excludedIds = new Set(excludedSlideIds.map(String));
  const activeSlidesById = new Map(
    activeSlides.map((slide) => [
      String(slide.SlideID || slide.id || ""),
      slide,
    ]),
  );

  const configuredBannerIds = new Set(
    configuredSlides.flatMap((slide) => [
      String(slide.sourceSlideId || ""),
      String(slide.id || "").replace(/^theme-slide-/, ""),
    ]),
  );
  const resolvedConfiguredSlides = configuredSlides
    .map((slide) => {
      const sourceSlide = activeSlidesById.get(
        String(slide.sourceSlideId || ""),
      );
      const image = sanitizeImageUrl(
        slide.imageUrl ||
          sourceSlide?.ImageData ||
          sourceSlide?.image ||
          sourceSlide?.ImageUrl,
      );
      const resolvedImage =
        image?.startsWith("/api/public/storefront-slides/")
          ? `${getBaseApiUrl()}${image}`
          : image;

      return {
        id: slide.id,
        title: slide.title || "",
        subtitle: slide.subtitle || "",
        description: slide.description || "",
        buttonText: slide.buttonText || "Shop now",
        image: resolvedImage,
        link: slide.buttonLink || sourceSlide?.LinkUrl || "/shop",
        altText:
          slide.subtitle ||
          slide.title ||
          sourceSlide?.ImageAltText ||
          "Store promotion",
        color: primaryColor || "#2c7da0",
        placement: slide.placement || "hero",
        pagePath: slide.pagePath || "/",
        afterProducts: slide.afterProducts || 4,
        sourceSlideId: slide.sourceSlideId || "",
      };
    });
  const configuredSlidesWithImages = resolvedConfiguredSlides.filter(
    (slide) => Boolean(slide.image),
  );
  const legacySlides = activeSlides
    .filter((slide) => {
      const slideId = String(slide.SlideID || slide.id || "");
      return (
        slideId &&
        !configuredBannerIds.has(slideId) &&
        !excludedIds.has(slideId)
      );
    })
    .map((slide) => {
      const image = sanitizeImageUrl(
        slide.ImageData || slide.image || slide.ImageUrl,
      );
      const resolvedImage =
        image?.startsWith("/api/public/storefront-slides/")
          ? `${getBaseApiUrl()}${image}`
          : image;
      const id = String(slide.SlideID || slide.id);
      return {
        id,
        title: slide.Title || "",
        subtitle: slide.Description || "",
        description: "",
        buttonText: "Shop now",
        image: resolvedImage,
        link: slide.LinkUrl || "/shop",
        altText: slide.ImageAltText || slide.Title || "Store promotion",
        color: primaryColor || "#2c7da0",
        placement: "hero",
        pagePath: "/",
        afterProducts: 4,
        sourceSlideId: id,
      };
    })
    .filter((slide) => Boolean(slide.image));
  return [...configuredSlidesWithImages, ...legacySlides];
};
